import type { Graph, Product } from 'schema-dts'
import type { EventDescription } from '~/composables/types/event'
import { organizationReference } from '~/composables/schemaOrg/useOrganizationSchema'

// Special giftcards (/giftcard/{slug}/) are sold at the fixed price shown in
// their buy box, which is the event's minimum price.
const useProductSchema = (events: EventDescription[]): any => {
  const schema = ref<Graph | undefined>(undefined)
  const script = computed(() => ({
    type: 'application/ld+json',
    innerHTML: schema.value,
  }))
  const fullLocalizedUrl = useFullLocalizedUrl()

  const createSchema = (): Product[] =>
    events.map((event) => {
      const url = fullLocalizedUrl(
        `/giftcard/${eventGetters.getPermalink(event)}/`
      )
      const price = Number(eventGetters.getMinimumPriceAmount(event)) / 100
      return {
        '@type': 'Product',
        '@id': `${url}#product`,
        name: eventGetters.getTitle(event),
        url,
        image: eventGetters.getSchemaImages(event),
        description: eventGetters.getSubtitle(event),
        category: 'Gift Card',
        brand: organizationReference,
        ...(price > 0 && { offers: getGiftcardOffer({ price, url }) }),
      }
    })

  schema.value = { '@context': 'https://schema.org', '@graph': createSchema() }

  return {
    schema,
    script,
  }
}

export default useProductSchema
